export const formatArticleStoryPageNumbers = (pageNumbers: number[]): string => {
    const pageLabel = pageNumbers.length <= 1 ? 'Page' : 'Pages';
    const sortedPages = pageNumbers.sort((a, b) => a - b);
    let groupEnd = '';

    const groupedPages = sortedPages.reduce((previous, current, idx, pages) => {
        const isConsecutiveNumber = current - pages[idx - 1] === 1;
        if (isConsecutiveNumber) {
            groupEnd = `-${current}`;
            return idx === pages.length - 1 ? `${previous}${groupEnd}` : previous;
        } else {
            const result = `${previous}${groupEnd}${previous ? ', ' : ''}${current}`;
            groupEnd = '';
            return result;
        }
    }, '');

    return `${pageLabel} ${groupedPages}`;
};
